<template>
  <section class="results">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: "ResultTemplate",
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.results {
  /deep/ .related-field {
    max-width: 100%;
  }

  /deep/ .related-field__cards {
    @include for-desktop {
      display: flex;
      max-width: 935px;
    }

    .related-field__card {
      margin-left: auto;
      margin-right: auto;

      @include for-tablet {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }

  /deep/ .paragraph__fields {
    padding: 0;
    border-left: 0;
    width: 100%;
  }

  /deep/ .album-collection {
    @include for-tablet {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 605px;
      margin: auto;
    }
  }
}
</style>
